export const JOIN_USER = 'JOIN_USER';